export const white = '#FFFFFF';
export const black = '#191919';
export const background = '#F5F5FB';
export const shadow = '#E6EBF6';

export const purple = {
  BRAND: '#7038A7',
  V1: '#854BBE',
  V2: '#A677D4',
  V3: '#D6BDF0',
  V4: '#E8DBF8',
  V5: '#FAF4FF',
  ACTIVE: '#8331D3',
};

export const magenta = {
  BRAND: '#E91171',
  V1: '#B10F57',
  V2: '#CF6594',
  V3: '#E5A2C0',
  V4: '#F9D6E6',
  V5: '#FFF6FA',
};

export const grey = {
  DARK: '#191919',
  V1: '#3D3D3D',
  V2: '#707070',
  V3: '#B8B8B8',
  V4: '#E5E5E5',
  V5: '#F5F5F5',
  A100: '#7F7F7F',
  A200: '#3A3A3A',
};

export const deepBlue = {
  MAIN: '#021D87',
  V1: '#102DA3',
  V2: '#4A62C7',
  V3: '#9EADEB',
  V4: '#CFD6F5',
  V5: '#F3F6FF',
};

export const blue = {
  MAIN: '#3683FD',
  V1: '#468EFF',
  V2: '#77ABFF',
  V3: '#9FC4FF',
  V4: '#D2E3FF',
  V5: '#F2F7FF',
};

export const green = {
  MAIN: '#11C0AE',
  V1: '#4CD0AA',
  V2: '#6DE1BF',
  V3: '#9AFADD',
  V4: '#CAFFEF',
  V5: '#F1FFFB',
};

export const red = {
  MAIN: '#FF3F65',
  V1: '#FF5B7C',
  V2: '#FF849C',
  V3: '#FFACBD',
  V4: '#FFD5DD',
  V5: '#FFF7F8',
};

export const orange = {
  MAIN: '#FF7250',
  V1: '#FF886B',
  V2: '#FFAA95',
  V3: '#FFC5B7',
  V4: '#FFE9E3',
  V5: '#FFF7F5',
};

export const yellow = {
  MAIN: '#FCAD3B',
  V1: '#FFD352',
  V2: '#FFDD79',
  V3: '#FFEAAD',
  V4: '#FFF4D6',
  V5: '#FFFBEF',
};

export const frost = {
  MAIN: '#636B75',
  V1: '#717A85',
  V2: '#A0A7B1',
  V3: '#BCC3CC',
  V4: '#E0E6EC',
  V5: '#F4F9FF',
};

export const alert = {
  INFO: '#297CDA',
  SUCCESS: '#20BF20',
  WARNING: '#F6AF22',
  ERROR: '#DA3529',
};

export default {
  purple,
  magenta,
  grey,
  white,
  black,
  background,
  deepBlue,
  blue,
  green,
  orange,
  yellow,
  frost,
  alert,
};
